import moment from "moment";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { getNoticeList } from "../../apis/Notice/apis";
import PageFilter from "../../components/molecures/PageFilter";
import PaginationTable from "../../components/molecures/PaginationTable";
import useSpecial from "../../hooks/useSpecial";
import { NoticeInfo } from "../../model/Notice";
import { HttpError } from "../../network/types";
import { alertError } from "../../shared/utils";
import { NoticeQueryKeys } from "./constants";

const Notice: React.FC = () => {
  const queryClient = useQueryClient();

  const { search } = useLocation();
  const nav = useNavigate();
  const { special } = useSpecial();
  const searchParams = new URLSearchParams(search);

  const location = useLocation();
  const [rows, setRows] = useState<NoticeInfo[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const getPageListMutation = useMutation(getNoticeList, {
    onSuccess: (res) => {
      setRows(res.rows || []);
      setTotalCount(res.count || 0);
    },
    onError: (err: HttpError) => {
      if (err.status !== 404) alertError(err.message);
      else queryClient.setQueryData(NoticeQueryKeys.NOTICE_LIST, []);
    },
  });
  const DEFAULT_PAGE = 1;
  const DEFAULT_PAGE_SIZE = 10;

  const QUERY_KEY_PAGE = "page";
  const QUERY_KEY_PAGE_SIZE = "pageSize";
  const getPaginationInfoFromQuery = () => {
    try {
      const pageInQuery = searchParams.get(QUERY_KEY_PAGE) || `${DEFAULT_PAGE}`;
      const pageSizeInQuery =
        searchParams.get(QUERY_KEY_PAGE_SIZE) || `${DEFAULT_PAGE_SIZE}`;
      const page = parseInt(pageInQuery, 10);
      const pageSize = parseInt(pageSizeInQuery, 10);
      return {
        page,
        pageSize,
      };
    } catch (e) {
      return {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };
    }
  };
  const { page, pageSize } = getPaginationInfoFromQuery();

  const pushPage = (page: number, pageSize: number, filterValues = {}) => {
    const { pathname } = location;
    const filterString = JSON.stringify(filterValues);

    const queryString = new URLSearchParams({
      page: `${page}`,
      pageSize: `${pageSize}`,
      query: filterString,
    }).toString();
    const nextUrl = `${pathname}?${queryString}`;
    nav(nextUrl);
  };

  const handlePageSizeChange = (nextPageSize: number) => {
    pushPage(1, nextPageSize);
  };

  const handlePaginationChange = (page: number) => {
    pushPage(page, pageSize);
  };
  useEffect(() => {
    getPageListMutation.mutate({ page, pageSize });
  }, [location]);

  const columns = [
    {
      dataIndex: "startedAt",
      title: "시작일",
      width: 152,
      render: (value: string, record: any) =>
        value
          ? moment(value).format("YYYY.MM.DD")
          : moment(record.createdAt).format("YYYY.MM.DD"),
    },

    { dataIndex: "title", width: 750, title: "제목", ellipsis: true },
  ];

  // useEffect(() => {
  //   onSearch();
  // }, [search]);

  return (
    <>
      <PageFilter
        title="공지사항"
        smallPageTitle="고객센터"
        inputs={[]}
        margin="0 0 24px 0px"
      />
      <PaginationTable
        headerTitle="공지사항 리스트"
        columns={columns}
        data={rows || []}
        totalCount={totalCount || 0}
        pageSize={pageSize}
        handleModal={null}
        isGenerateBanned
        onRow={(record) => {
          return {
            onClick: () => {
              const prefix = special.includes("speedMateCode")
                ? "/speed-mate"
                : special.includes("autooasisCode")
                ? "/autooasis"
                : "";
              nav(`${prefix}/notices/${record.id}`);
            },
          };
        }}
        onPageChanged={handlePaginationChange}
        onPageSizeChanged={handlePageSizeChange}
        currentPage={page || 1}
        isLoading={getPageListMutation.isLoading}
      />
    </>
  );
};
export default Notice;
